module.exports = __webpack_public_path__ + "static/img/wxqr.8e86465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wxqr.png
// module id = uTwv
// module chunks = 14